import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { IOrganization, IAccount } from '../../../interfaces/graph-types';
import { OrganizationService } from '../../../services/organization.service';

@Component({
  selector: '[account-selector]',
  template: require('./account-selector.component.pug'),
  styles: [require('./account-selector.component.css').toString()],
})
export class AccountSelectorComponent implements OnInit, OnDestroy {
  subOrg: Subscription;
  subAcc: Subscription;
  isLoading: boolean;
  step = 0;
  selectedOrg: IOrganization = null;
  selectedAccount: IAccount = null;
  orgs: IOrganization[] = null;
  accounts: IAccount[] = null;

  // -------------------------------------------------------------------
  constructor(private orgService: OrganizationService) {
    this.isLoading = true;
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.subOrg = this.orgService.getOrgs().subscribe(res => {
      this.orgs = res.organizations;
      this.step = 1;
      if (this.orgs.length == 1) {
        this.selectOrg(this.orgs[0]);
      }
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    if (this.subOrg) this.subOrg.unsubscribe();
    if (this.subAcc) this.subAcc.unsubscribe();
  }

  // -------------------------------------------------------------------
  selectOrg(org) {
    this.selectedOrg = org;
    this.step = 2; // time to select account
    this.subAcc = this.orgService.getAccountList(org.id).subscribe(res => {
      this.accounts = res.accounts;
      if (this.accounts.length == 1) {
        this.selectAccount(this.accounts[0]);
      }
    });
  }

  // -------------------------------------------------------------------
  selectAccount(account) {
    this.selectedAccount = account;
    this.step = 3; // fake loading while waiting redirect
    window.location.href = '/account_selector/' + account.id;
  }
}
